import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

export type KeyHandoverStepId =
  | "handoverSchedule"
  | "returnSchedule"
  | "host"
  | "guest"
  | "summary";

/**
 * Centralized step counter for the Key Handover flow.
 * Excludes the payment step from the counter by design.
 */
export function useKeyHandoverStepCounter(currentStep: KeyHandoverStepId) {
  const selectedServiceType = useSelector(
    (state: RootState) => state.bookingCreation.keyHandoverSelectedService
  );
  const isCombined = selectedServiceType === "Key-Pickup-And-Return";

  // Check for customerAgreementId in the URL
  let customerAgreementId: string | null = null;
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    customerAgreementId = params.get("customerAgreementId");
  }

  let singleSteps: KeyHandoverStepId[] = [
    "handoverSchedule",
    "host",
    "guest",
    "summary",
  ];
  let combinedSteps: KeyHandoverStepId[] = [
    "handoverSchedule",
    "returnSchedule",
    "host",
    "guest",
    "summary",
  ];

  if (customerAgreementId) {
    singleSteps = singleSteps.filter((step) => step !== "host");
    combinedSteps = combinedSteps.filter((step) => step !== "host");
  }

  const steps = isCombined ? combinedSteps : singleSteps;
  const index = Math.max(0, steps.indexOf(currentStep));
  const current = index + 1; // 1-based display
  const total = steps.length;

  return { current, total, isCombined };
}
